import { Button, ModalPanel, Title } from "dash-styled"
import React, { useCallback } from "react"
import { useInput } from "../../../../../../../../../Hooks/useInput"
import { StructuredSequence } from "../../../../../../../../../Hooks/useStructuredTrainingQuestionTutorial"
import { Explanation } from "./Explanation"

interface TutorialExplanationModalProps {
    question?: StructuredSequence
    onClose: () => void
    onAddQuestion: (question: {
        hint?: string
        explanation?: string
    }) => Promise<void>
    onEditQuestion: (id: string, hint?: string, explanation?: string) => void
    isAdding: boolean
}

export const TutorialExplanationModal = ({
    question,
    onClose,
    onAddQuestion,
    onEditQuestion,
    isAdding
}: TutorialExplanationModalProps) => {
    const { value: hint, onChange: onHintChange } = useInput(
        question?.summary.hint ?? ""
    )
    const { value: explanation, onChange: onExplanationChange } = useInput(
        question?.summary.explanation ?? ""
    )

    const handleSave = useCallback(async () => {
        if (question?.id !== undefined) {
            await onEditQuestion(question.id, hint, explanation)
        } else {
            await onAddQuestion({ hint, explanation })
        }
        onClose()
    }, [explanation, hint, onAddQuestion, onClose, onEditQuestion, question])

    const actionText = question?.id !== undefined ? "Update" : "Add"
    const actionPerformingText =
        question?.id !== undefined ? "Updating..." : "Adding..."
    const buttonText = isAdding ? actionPerformingText : actionText
    return (
        <ModalPanel
            testId="tutorial-explanation-modal"
            onClose={onClose}
            className="max-w-2xl w-full"
        >
            <Title variant="heading2" weight="semibold">
                Tutorial explanation
            </Title>
            <Explanation
                hint={hint}
                onHintChange={onHintChange}
                explanation={explanation}
                onExplanationChange={onExplanationChange}
            />
            <div className="flex justify-center pt-4">
                <Button
                    onClick={handleSave}
                    testId="tutorial-explanation-add-button"
                    className="w-max-content"
                    disabled={!hint || !explanation || isAdding}
                >
                    {buttonText}
                </Button>
            </div>
        </ModalPanel>
    )
}
